<template>
  <span>Вы уверены, что хотите закрыть счет на сумму <strong>{{ balance }}</strong> под номером: <br><strong>{{ invoice }}</strong></span>
</template>

<script>
  import utils from '../../../../utils';
  import { mapGetters } from 'vuex';

  export default {
    name: "removeInvoiceInfoLabel",
    computed: {
      ...mapGetters(['invoiceToRemove', 'currency']),
      invoice() {
        return utils.formatInvoice(this.invoiceToRemove.invoice);
      },
      balance() {
        return utils.convertSystemToCurrency(this.invoiceToRemove.balance, this.currency);
      },
    },
  }
</script>

<style scoped>
  span {
    color: #666;
    margin-bottom: 2px;
    margin-left: -4px;
    vertical-align: center;
    font-size: 14px;
    font-family: Lucida Grande,Lucida Sans,Arial,sans-serif;
  }
</style>
